import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EmissionOverviewComponent } from './emission-overview.component';

const routes: Routes = [
  {
    path: '',
    component: EmissionOverviewComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EmissionOverviewRoutingModule {}
